import { useTranslation } from 'react-i18next';
import { Link } from 'react-scroll';
import './Header.css';

function Header() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // adjust this value based on your header height (e.g. -60)
  const scrollOffset = -80;

  return (
    <header className="header">
      <div className="header-logo">
        <img src="/images/vilasol_logo_clean.svg" alt="Vila Sol Caffe Logo" />
      </div>
      <nav className="nav-links">
        <Link to="about" smooth duration={600} offset={scrollOffset}>{t('nav.about')}</Link>
        <Link to="menu" smooth duration={600} offset={scrollOffset}>{t('nav.menu')}</Link>
        <Link to="gallery" smooth duration={600} offset={scrollOffset}>{t('nav.gallery')}</Link>
        <Link to="contact" smooth duration={600} offset={scrollOffset}>{t('nav.contact')}</Link>
      </nav>
      <div className="language-switcher">
        <button onClick={() => changeLanguage('en')}>EN</button>
        <button onClick={() => changeLanguage('pt')}>PT</button>
        <button onClick={() => changeLanguage('fr')}>FR</button>
      </div>
    </header>
  );
}

export default Header;
